import { RootState } from "../store";

export const selectBeneficiaryRelationshipTypes = (state: RootState) => state.beneficiaryRelationshipTypes.list;
